// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "details-3wUMf";
var _3 = "info-1h_vh";
var _4 = "info__item-2pbta";
var _5 = "order-2CSU8";
var _6 = "order__prefix-3HDfW";
var _7 = "order__button-3OCNM";
export { _1 as "__esModule", _2 as "details", _3 as "info", _4 as "info__item", _5 as "order", _6 as "order__prefix", _7 as "order__button" }
export default { "__esModule": _1, "details": _2, "info": _3, "info__item": _4, "order": _5, "order__prefix": _6, "order__button": _7 }
